import { CancelAsync } from './../../app/models/cancelAsync';
import { Component, HostListener, Renderer2, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import {
  NavController,
  Platform,
  ModalController,
  DomController,
} from '@ionic/angular';

import { ModalIframeComponent } from '@app/modals';

import { ToasterService, UtilsService } from '@commons/services';

import {
  PageLoaderService,
  AppInitService,
  StatsService,
  StorageService,
  StudentService,
  CouponsService,
  ConfigUserService,
  NetworkStatusService,
  NavigationService,
  GamificationService,
} from '@app/services';

import { Student } from '@app/models';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';

@EasyDebugDecorator
@Component({
  selector: 'parrainage-page',
  templateUrl: 'parrainage.page.html',
  styleUrls: ['parrainage.page.scss'],
})
export class ParrainagePage extends CancelAsync {
  isDebug = false;
  showLogs = false;

  student: Student;
  userLifeCycle: any;
  configUser: any;

  longLoading = false;
  pageStart = Date.now();
  checkPageLoadingTimeInterval: any;
  initPageDone = false;
  pageLoaded = false;

  iconPath = './uikit-assets/icons/orion-svg-sprite.svg#';
  iconThemePath = './uikit-assets/icons/orion-svg-sprite-theme.svg#';

  pageTitle = 'Cours';
  activeLink = 'code';
  blocHeaderTitle = `Profil`;
  blocHeaderBackTitle = 'Profil';
  blocHeaderBackUrl = 'profil';
  isBackBtn = true;

  screenWidth: number = window.innerWidth;
  isDesktop: boolean = this.screenWidth > 767 ? true : false;
  isCordova = false;

  stepChangeSub: any;
  pageLoaderSteps = [
    'init0',
    'init1',
    'init2',
    'init3',
    'init4',
    'init5',
    'initPage',
  ];
  hasMadeInit = false;

  objectKeys = Object.keys;

  navigationSubscription: any;

  initDataReady = false;
  statsSent = false;

  parrainageCode: any = 'chargement en cours...';
  parrainageCodeDiscount: any = 0;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.screenWidth = window.innerWidth;
    this.isDesktop = this.screenWidth > 767 ? true : false;
  }

  constructor(
    public pageLoaderService: PageLoaderService,
    private appInitService: AppInitService,
    private navController: NavController,
    private statsService: StatsService,
    public router: Router,
    private studentService: StudentService,
    private couponsService: CouponsService,
    private navigationService: NavigationService,
    private networkService: NetworkStatusService,
    public utils: UtilsService,
    public toasterService: ToasterService,
    public platform: Platform,
    public modalController: ModalController,
    public gamificationService: GamificationService,
    public renderer: Renderer2,
    public domCtrl: DomController
  ) {
    super({ cancel: false, subscription: null });

    this.checkPageLoadingTimeInterval = setInterval(() => {
      const now = Date.now();
      // 3 sec
      if (now - this.pageStart >= 3000) {
        this.longLoading = true;
        clearInterval(this.checkPageLoadingTimeInterval);
      }
    }, 200);

    if (!this.appInitService.done) {
      this.navigationService.timestamp = Date.now();
      this.navigationService.lastLink = this.router.url.substr(1);
      this.hasMadeInit = true;
    } else {
      this.hasMadeInit = false;
    }

    this.isCordova = this.platform.is('cordova');

    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        if (
          !!this.navigationService.lastLink &&
          this.navigationService.lastLink === this.router.url.substr(1)
        ) {
          this.hasMadeInit = true;
          this.initPageDone = false;
          if (this.appInitService.done) {
            this.blocHeaderTitle = `Profil`;
            this.blocHeaderBackTitle = 'Profil';
            this.blocHeaderBackUrl = 'profil';
            this.pageLoaderSteps = ['initApp', 'initPage'];
          } else {
            this.pageLoaderSteps = [
              'init0',
              'init1',
              'init2',
              'init3',
              'init4',
              'init5',
              'initPage',
            ];
          }
        }
      }
    });

    if (this.appInitService.done) {
      this.pageLoaderSteps = ['initApp', 'initPage'];
      this.pageLoaderService.setSteps(
        this.pageLoaderSteps.indexOf('initApp') + 1,
        this.pageLoaderSteps.length
      );
    }
    this.stepChangeSub = this.appInitService.onStepChange().subscribe(state => {
      if (state?.init >= 2 && state?.stepDone && !this.initPageDone) {
        this.initPage();
      }
      if (state?.init && state?.stepDone) {
        this.pageLoaderService.setSteps(
          state.init + 1,
          this.pageLoaderSteps.length
        );
      }
      if (state?.initDone) {
        this.initPage();
      }
    });
  }

  ionViewWillLeave() {
    // this.cancel = true;
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (!!this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    if (!!this.stepChangeSub) {
      this.stepChangeSub.unsubscribe();
    }
  }

  evslog(...args: any[]) {
    if (this.showLogs) {
      if (window.console) {
        console.log.apply(console, arguments);
      }
    }
  }

  async initPage() {
    this.student = this.studentService.student;
    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student);
    // this.configUser = await this.configUserService.getUserConfig(this.student);

    if (this.networkService?.isOffline()) {
      this.navigationService.saveLinkToReload();
    }

    const resParrainageCode = await this.couponsService.fetchParrainageCode(
      this.student.remoteId
    );
    if (
      !!resParrainageCode &&
      !!resParrainageCode.errorCode &&
      resParrainageCode.errorCode === 'E301'
    ) {
      const toasterConfig = {
        text: `Une erreur est survenue, réessaie plus tard`,
        bgcolor: 'var(--color-danger)',
        duration: '5000',
      };
      this.launchToaster(toasterConfig);
    } else {
      this.parrainageCode = !!resParrainageCode.attributes.name
        ? resParrainageCode.attributes.name
        : this.parrainageCode;
      this.parrainageCodeDiscount =
        !!resParrainageCode.attributes.discount &&
        !isNaN(Number(resParrainageCode.attributes.discount))
          ? Number(resParrainageCode.attributes.discount) / 100
          : this.parrainageCodeDiscount;
    }

    this.pageLoaded = true;
    this.initPageDone = true;

    if (this.initDataReady) {
      // PAGE LOAD EVENT
      if (
        !!this.navigationService.timestamp &&
        !!this.navigationService.lastLink
      ) {
        const statObj = {
          page: this.navigationService.lastLink,
          loadTime: Date.now() - this.navigationService.timestamp,
          withInit: this.hasMadeInit,
        };
        if (this.statsService.isDebug) {
          console.log(statObj);
        }
        this.statsService.send({ name: 'page:view', payload: statObj });
        this.statsSent = true;
      }
    }
    this.pageLoaderService.setSteps(
      this.pageLoaderSteps.indexOf('initPage') + 1,
      this.pageLoaderSteps.length
    );
    setTimeout(() => {
      this.pageLoaderService.stepsDone();
    }, 300);
  }

  copyCode() {
    if (this.parrainageCode !== 'chargement en cours...') {
      navigator.clipboard.writeText(this.parrainageCode);
      const toasterConfig = {
        text: `Code copié`,
        bgcolor: 'var(--color-success)',
        duration: '5000',
      };
      this.launchToaster(toasterConfig);
    }
  }

  launchToaster(config) {
    this.toasterService.create(config);
  }

  async openModalIframe(url: any, type?: string, noClose = true) {
    if (!type) {
      type = 'iframe';
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        backdropDismiss: false,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    } else {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    }
    return await modal.present();
  }

  async openLink(link) {
    // console.log(link);
    let callbackUrl;
    if (this.utils.isDefined(link)) {
      callbackUrl = await this.navigationService.open(link, null);
      if (!!callbackUrl && callbackUrl !== '') {
        this.openModalIframe(callbackUrl);
      }
    } else {
      this.navController.back();
    }
  }
}
